// @ts-nocheck
import React from 'react';

const Radio = React.forwardRef(({ className = '', label, ...rest }, ref) => {
  const r = (
    <input
      ref={ref}
      type="radio"
      className={['mov-radio', className].join(' ')}
      style={{
        appearance: 'none',
        WebkitAppearance: 'none',
        width: 16, height: 16,
        border: '1px solid var(--mov-line-strong)',
        borderRadius: '50%',
        background: 'var(--mov-paper)',
        display: 'grid',
        placeItems: 'center',
        cursor: 'pointer',
        margin: 0,
        verticalAlign: 'middle',
        flexShrink: 0,
      }}
      {...rest}
    />
  );
  if (!label) return r;
  return (
    <label className="inline-flex items-center gap-2 cursor-pointer text-[13px] text-mov-ink">
      {r}
      <span>{label}</span>
    </label>
  );
});
Radio.displayName = 'Radio';

/**
 * RadioCard — option card with title + sub line. Drives off `checked` so it
 * can be used standalone or inside a controlled group.
 */
export const RadioCard = ({ checked, onClick, title, sub, className = '' }) => (
  <button
    type="button"
    onClick={onClick}
    aria-pressed={checked}
    className={['text-left p-3 border rounded-md2 transition-colors cursor-pointer', className].join(' ')}
    style={{
      borderColor: checked ? 'var(--mov-accent)' : 'var(--mov-line-strong)',
      background: checked ? 'var(--mov-accent-soft)' : 'var(--mov-paper-2)',
      boxShadow: checked ? '0 0 0 3px var(--mov-accent-soft)' : 'none',
      color: checked ? 'var(--mov-accent-ink)' : 'var(--mov-ink)',
    }}
  >
    <div className="text-[12.5px] font-semibold">{title}</div>
    {sub && <div className="text-[11.5px] mt-0.5" style={{ color: checked ? 'var(--mov-accent-ink)' : 'var(--mov-ink-mute)' }}>{sub}</div>}
  </button>
);

export default Radio;
